var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BaseEntity, MemoizeGetters, Transform, toEntity } from './base';
import { NoteModel } from './note';
import { parseLocationName } from './base/util';
let AddressModel = class AddressModel extends BaseEntity {
    get details() {
        return parseLocationName(this.locationName);
    }
    get regionName() {
        if (this.isLA()) {
            return RegionName.LA;
        }
        else {
            return RegionName.Unknown;
        }
    }
    isLA() {
        const center = new google.maps.LatLng(34.038155, -118.274114);
        const radius = 1609 * 50;
        const addressLatLng = new google.maps.LatLng(this.lat, this.lng);
        const distance = google.maps.geometry.spherical.computeDistanceBetween(addressLatLng, center);
        return distance < radius;
    }
    get infoComplete() {
        return ((this.addressType && this.parkingLotSize && this.parkingLotType) !== null);
    }
};
__decorate([
    Transform(toEntity(NoteModel)),
    __metadata("design:type", Array)
], AddressModel.prototype, "notes", void 0);
AddressModel = __decorate([
    MemoizeGetters
], AddressModel);
export { AddressModel };
export var RegionName;
(function (RegionName) {
    RegionName["LA"] = "Los Angeles";
    RegionName["Unknown"] = "Unknown";
})(RegionName || (RegionName = {}));
//# sourceMappingURL=address.js.map


// WEBPACK FOOTER //
// ./src/models/address.ts.pre-build-optimizer.js